import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DiagnosisTreatmentsEffects } from './diagnosis-treatments.effects';
import { Reducer } from './diagnosis-treatments.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('diagnosis-treatments', Reducer),
    EffectsModule.forFeature([DiagnosisTreatmentsEffects]),
  ],
  providers: [DiagnosisTreatmentsEffects],
})
export class DiagnosisTreatmentsModule {}
